module.exports = __webpack_public_path__ + "static/img/technology5.f36e108a.png";